import { render } from "./TotalInventory.vue?vue&type=template&id=0621274c"
import script from "./TotalInventory.vue?vue&type=script&lang=js"
export * from "./TotalInventory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Reports/PhysicalInventory/TotalInventory.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0621274c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0621274c', __exports__)) {
    api.reload('0621274c', __exports__)
  }
  
  module.hot.accept("./TotalInventory.vue?vue&type=template&id=0621274c", () => {
    api.rerender('0621274c', render)
  })

}


export default __exports__